import React, { useEffect } from 'react';
import { Pane } from 'tweakpane';
import * as EssentialsPlugin from '@tweakpane/plugin-essentials';

import {
  getTweakpane,
  setTweakpane,
} from '#state/gui';


const PaneState = () => {
  useEffect(() => {
    const pane = new Pane({
      container: document.getElementById('tweakpane'),
      title: 'Settings',
      expanded: false,
    });
    pane.registerPlugin(EssentialsPlugin);

    setTweakpane(pane);

    return () => {
      pane.dispose()
      setTweakpane(null);
    }
  }, [])

  // useEffect(() => {
  //   const pane = getTweakpane()
  //   if (!pane) return () => {}

  //   const fl = pane.addFolder({
  //     title: 'Base',
  //     expanded: false,
  //   });

  //   const PARAMS = {
  //     factor: 123,
  //     title: 'hello',
  //     color: '#ff0055',
  //   };
  //   fl.addBinding(PARAMS, 'factor', {
  //     label: 'Trading',
  //   }).on('change', (ev) => {
  //     console.log(ev.value);
  //     if (ev.last) {
  //       console.log('(last)');
  //     }
  //   })
  //   fl.addBinding(PARAMS, 'title');
  //   fl.addBinding(PARAMS, 'color');

  //   return () => {
  //     // fl.dispose()
  //   }
  // }, [])


  return null
};

export { PaneState }

